import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import About from "./components/About";
import DziBeads from "./components/DziBeads";
import Crystals from "./components/Crystals";
import Jade from "./components/Jade";
import Thangka from "./components/Thangka";
import QuizSection from "./components/QuizSection";
import Knowledge from "./components/Knowledge";
import FeaturedProducts from "./components/FeaturedProducts";
import Testimonials from "./components/Testimonials";
import TrustBadges from "./components/TrustBadges";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <Hero />
      <About />
      <DziBeads />
      <Crystals />
      <Jade />
      <Thangka />
      <QuizSection />
      <Knowledge />
      <FeaturedProducts />
      <Testimonials />
      <TrustBadges />
      <FinalCTA />
      <SiteFooter />
    </main>
  );
}
